import React, { FC } from 'react'
import { t } from '@lingui/macro'
import styles from './EmptyList.module.scss'
import { Button } from 'pages/native/onBoarding/components'

interface EmptyListProps {
  onReset: () => void
}

export const EmptyList: FC<EmptyListProps> = ({ onReset }) => {
  return (
    <div className={styles.ContentContainer}>
      <p className={styles.EmptyListLabel}>
        Oppss... We couldn’t find any team matching your search. Try searching
        for something else or click the button below to follow top teams.
      </p>
      <Button
        label={t`Browse Top Teams`}
        variant="filled"
        theme="primary"
        onClick={onReset}
      />
    </div>
  )
}
